<template>
    <div id="informDetail">
        <div class="sectionHeader isFixed" ref="mainHeader" v-if="mShowHeader">
            <div class="">
                <mainHeader class="mainHeader"></mainHeader>
            </div>
        </div>
        <div class="headerIsShow" v-if="mShowHeader"></div>
        <div class="i-back">
            <span class="lable-title m-left">消息详情</span>
            <span class="lable-time m-right" @click="back()">返回上一页></span>
        </div>
        <div class="i-space"></div>
        <div class="i-info">
            <span class="lable-title m-left">{{mMsgInfoTitle}}</span>
            <span class="lable-time m-left i-top">{{callTime(mMsgInfoTime)}}</span>
            <div class="i-xian"></div>
            <div class="i-content m-left m-right i-top">
                {{mMsgInfoContent}}
            </div>
        </div>
    </div>
</template>
<script>
import mainHeader from '@/view/header'
export default {
    name:'',
    components: {
        mainHeader
    },
    data () {
        return {
            mShowHeader: true,
            mMsgInfoTime: '',
            mMsgInfoTitle: '',
            mMsgInfoContent: '',
        }
    },
    methods: {
        back: function() {
            this.$router.back(-1)
        },
        getMsgInfo: function(id) {
            var that = this
            this.utils.GET(this.companyUrl + '/message/getinfo/' + id, (resultData) => {
                that.mMsgInfoTime = resultData.data.create_time
                that.mMsgInfoTitle = resultData.data.tails.msg_title
                that.mMsgInfoContent = resultData.data.tails.msg_text 
            })
        },
        callTime: function(time) {
            if (time === undefined || time === NaN || time === null || time.length <= 0) {
                return ''
            }
            var nowDate = new Date()
            var msgDate = new Date(time)

            var nowTime = nowDate.getTime() // 当前时间戳
            var msgTime = msgDate.getTime()

            var dateDiff = nowTime - msgTime
            // 计算出相差天数
            var dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000)); 
            var leave1 = dateDiff % (24 * 3600 * 1000); // 计算天数后剩余的毫秒数
            var hours = Math.floor(leave1 / (3600 * 1000)); // 计算出小时数
            // 计算相差分钟数
            var leave2 = leave1 % (3600 * 1000); // 计算小时数后剩余的毫秒数
            var minutes = Math.floor(leave2 / (60 * 1000)); // 计算相差分钟数
            // 计算相差秒数
            var leave3 = leave2 % (60 * 1000); // 计算分钟数后剩余的毫秒数
            var seconds = Math.round(leave3 / 1000);
            console.log("相差" + dayDiff + "天" + hours + "小时" + minutes + "分钟" + seconds + "秒");
            var newTime = time
            if (dayDiff <= 0) {
                var todayNum = nowDate.getFullYear() + nowDate.getUTCMonth() + nowDate.getUTCDate()
                var msgNum = msgDate.getFullYear() + msgDate.getUTCMonth() + msgDate.getUTCDate()
                if (todayNum === msgNum) {
                    return newTime.substring(newTime.indexOf(' '), newTime.lastIndexOf(':'))
                } else {
                    return "昨天" + newTime.substring(newTime.indexOf(' '), newTime.lastIndexOf(':'))
                }
            } else {
                return newTime
            }
        }
    },
    created () {
        if (this.$route.query.isApp == 1 && this.$route.query.type == 1) {
            localStorage.setItem('enterType', this.$route.query.type)
            localStorage.setItem('isApp', this.$route.query.isApp)
        }
        if (this.$route.query.isApp == 1 || localStorage.getItem('isApp') == 1) {
            this.mShowHeader = false
        } else {
            this.mShowHeader = true
        }
        console.log(this.mShowHeader)
    },
    beforeCreate () {
      document.querySelector('body').setAttribute('style', 'background-color:#f2f2f2;')
    },
    mounted () {
        var id = this.$route.query.id
        this.getMsgInfo(id)
    }
}

</script>


<style lang='scss' scoped>
    .sectionHeader {
        height: 55px;
        width: 100%;
        z-index: 900;
    }
    .sectionHeader.isFixed {
        position: fixed;
        top: 0px;
        height: 55px;
        width: 100%;
        z-index: 900;
    }
    .headerIsShow {
        margin-top: 55px;
    }
    .m-top {
        margin-top: 5px;
    }
    .m-left {
        margin-left: 13px;
    }
    .m-right {
        margin-right: 13px;
    }
    .i-back {
        height: 50px;
        display: flex;
        background-color: #ffffff;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }
    .lable-title {
        color: #000000;
        font-size: 16px;
        font-weight: bold;
    }
    .lable-time {
        color: #808080;
        font-size: 12px;
    }
    .i-space {
        height: 15px;
        background-color: #f2f2f2;
        width: 100%;
    }
    .i-info {
        background-color: #ffffff;
        display: flex;
        width: 100%;
        flex-direction: column;
        padding-top: 20px;
        padding-bottom: 13px;
        .i-top {
            margin-top: 10px;
        }
        .i-xian {
            height: 1px;
            background-color: #f2f2f2;
            margin-left: 13px;
            margin-top: 15px;
        }
        .i-content {
            color: #000000;
            font-size: 13px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/view/procurement/informDetail.vue